"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAppProtocolsFromRaw = void 0;
const getAppProtocolsFromRaw = appProtocols => appProtocols.reduce((acc, protocol) => {
  const {
    columns: _columns,
    app_protocol,
    ...rest
  } = protocol;
  acc[app_protocol] = rest;
  return acc;
}, {});
exports.getAppProtocolsFromRaw = getAppProtocolsFromRaw;